import React from "react"
import styled from "styled-components"
import colors from "@constants/colors"
import { smallcapsBold13Styles, body16MainStyles } from "@constants/typography"
import { Chevron } from "@components/icons"
import { ModalBaseProps } from ".."
import Review from "@components/Review"
import Stars from "@components/Stars"
import { YotpoReview } from "../../../reviews/types"
import { getIn } from "@utils/index"

const Container = styled.div`
  padding-top: 72px;
`

const Header = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  padding: 0 20px;
  border-bottom: 1px solid ${colors.dividerLineGray};
`

const BackButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const BackButtonIcon = styled.div`
  width: 32px;
  height: 32px;
  margin-right: 8px;
  padding: 0;
  transform: rotate(180deg) translateY(1px);
`

const BackButtonText = styled.div`
  ${smallcapsBold13Styles}
  padding-top: 2px;
`

const HeaderButton = styled.button`
  ${smallcapsBold13Styles}
  display: flex;
  min-width: 144px;
  height: 40px;
  padding: 4px 8px 0;
  justify-content: center;
  align-items: center;
  color: ${colors.offWhite};
  text-align: center;
  background: ${colors.black};
  border: none;
  border-radius: 2px;
  outline: none;
`

const Content = styled.div`
  display: flex;
  padding: 0 20px;
  flex-direction: column;
`

const Banner = styled.div`
  display: flex;
  height: 72px;
  margin-bottom: 44px;
  padding: 0 20px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: ${colors.dividerLineGray};
`

const BannerText = styled.div`
  ${body16MainStyles}
  color: ${colors.black};
`

const StyledReview = styled(Review)`
  margin-bottom: 32px;
  padding-bottom: 20px;
  border-bottom: 1px solid ${colors.dividerLineGray};
`

interface MobileReviewsModalProps extends ModalBaseProps {
  reviews: YotpoReview[]
  avgRating: number
  numReviews: number
  onClickImage: (id) => void
  onClickWriteReview: () => void
}

const MobileReviewsModal = ({
  reviews,
  avgRating,
  numReviews,
  onClickImage,
  onClickWriteReview,
  ...rest
}: MobileReviewsModalProps) => (
  <Container>
    <Header>
      <BackButton onClick={rest.onRequestClose}>
        <BackButtonIcon>
          <Chevron strokeColor={colors.black} />
        </BackButtonIcon>
        <BackButtonText>Reviews</BackButtonText>
      </BackButton>
      <HeaderButton onClick={() => onClickWriteReview()}>
        Write a review
      </HeaderButton>
    </Header>
    <Banner>
      <BannerText>{`${numReviews} Reviews`}</BannerText>
      <Stars stars={Math.round(avgRating)} />
    </Banner>
    <Content>
      {reviews.map((review) => (
        <StyledReview
          key={getIn(review, "id")}
          data={review}
          onClickImage={onClickImage}
        />
      ))}
    </Content>
  </Container>
)

export default MobileReviewsModal
